import { cn } from "@/lib/utils";
import { useTranslation } from 'react-i18next';

const statusConfig = {
  submitted: {
    className: "bg-blue-100 text-blue-800 border-blue-200",
  },
  assigned: {
    className: "bg-orange-100 text-orange-800 border-orange-200",
  },
  document_verification: {
    className: "bg-amber-100 text-amber-800 border-amber-200",
  },
  field_verification: {
    className: "bg-purple-100 text-purple-800 border-purple-200",
  },
  under_review: {
    className: "bg-indigo-100 text-indigo-800 border-indigo-200",
  },
  revenue_approved: {
    className: "bg-teal-100 text-teal-800 border-teal-200",
  },
  survey_inspection: {
    className: "bg-cyan-100 text-cyan-800 border-cyan-200",
  },
  boundary_verification: {
    className: "bg-sky-100 text-sky-800 border-sky-200",
  },
  sketch_preparation: {
    className: "bg-violet-100 text-violet-800 border-violet-200",
  },
  order_issued: {
    className: "bg-lime-100 text-lime-800 border-lime-200",
  },
  map_preparation: {
    className: "bg-violet-100 text-violet-800 border-violet-200",
  },
  approved: {
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  rejected: {
    className: "bg-red-100 text-red-800 border-red-200",
  },
};

export default function StatusBadge({ status }) {
  const { t } = useTranslation();
  const config = statusConfig[status] || statusConfig.submitted;
  
  return (
    <span
      className={cn(
        "px-2.5 py-0.5 rounded-full text-xs font-medium uppercase tracking-wide border",
        config.className
      )}
      data-testid={`status-badge-${status}`}
    >
      {t(`status.${status}`)}
    </span>
  );
}